import { number, string, func, bool, oneOfType } from 'prop-types';

export default {
  index: number.isRequired,
  member: string.isRequired,
  remove: func.isRequired,
  change: func.isRequired,
  expanded: oneOfType([string, bool]).isRequired,
  handleSetExpanded: func.isRequired
};
